// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Orders_CheckQrcodeUniqueResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for GET /so/orders/check_qrcode_unique
 *
 * Whether a QR code is available (unique) for the franchise: no undelivered
 * item of a not cancelled/entregue order holds it.
 *
 * Default false so any error/guard path stays fail-closed (never reports an
 * unchecked QR as available).
 *
 * in_use_*: who holds the QR when unique is false (order id, client name and
 * order status code); null when the QR is available.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Orders_CheckQrcodeUniqueResponseDados {
unique: boolean
in_use_order_id?: number
in_use_client_name?: string
in_use_order_status?: string
}

export type Orders_CheckQrcodeUniqueResponse = ApiResponse<Orders_CheckQrcodeUniqueResponseDados>;

registerResponseContract('Orders_CheckQrcodeUniqueResponse', {
  unique:              { type: 'boolean', required: true },
  in_use_order_id:     { type: 'number',  required: false },
  in_use_client_name:  { type: 'string',  required: false },
  in_use_order_status: { type: 'string',  required: false },
})
